import { useEffect } from 'react';

export default function SmartVisitorProvider() {
	useEffect(() => {
		// Load SmartVisitor SDK
		const script = document.createElement('script');
		script.src = 'http://164.128.130.8/smartVisitor/sdk-v1.js';
		script.onload = () => {
			if (window.SmartVisitor) {
				window.SmartVisitor.init({
					siteId: 'sv__Q--Y0REbr',
					apiKey: 'sk_KOU6b7dFRZECPDA8iXa6S_CLW6KICLO_',
				});
				console.log('SmartVisitor SDK loaded and initialized');
			} else {
				console.error('SmartVisitor SDK failed to load');
			}
		};
		script.onerror = () => {
			console.error('Failed to load SmartVisitor SDK script');
		};
		document.head.appendChild(script);

		// Cleanup function to remove script when component unmounts
		return () => {
			const existingScript = document.querySelector(
				'script[src="/smartvisitor-sdk.js"]',
			);
			if (existingScript) {
				existingScript.remove();
			}
		};
	}, []);

	return <></>;
}
